import { styled, alpha, Box, TextField, ListItemButton } from '@mui/material';
import { FONT_MONO } from 'themes/tokens';

export const ColumnSearchField = styled(TextField)(({ theme }) => ({
  '& .MuiOutlinedInput-root': {
    borderRadius: '12px',
    backgroundColor: theme.palette.background.default,
    '& .MuiOutlinedInput-notchedOutline': { borderColor: theme.palette.divider },
    '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: alpha(theme.palette.primary.main, 0.5) },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: theme.palette.primary.main },
  },
  '& .MuiInputAdornment-root': { color: theme.palette.text.secondary },
}));

export const ColumnGroupHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: theme.spacing(1.25),
  padding: theme.spacing(1, 1.5),
  marginBottom: theme.spacing(0.5),
  borderRadius: 10,
  backgroundColor: alpha(theme.palette.primary.main, 0.06),
  border: `1px solid ${theme.palette.divider}`,
}));

export const ColumnGroupIcon = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'nodeColor',
})<{ nodeColor: string }>(({ theme, nodeColor }) => ({
  flexShrink: 0,
  width: 30,
  height: 30,
  borderRadius: '8px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: nodeColor,
  color: theme.palette.getContrastText(nodeColor),
  boxShadow: `0 2px 8px ${alpha(nodeColor, 0.5)}`,
  '& svg': { fontSize: 17 },
}));

export const ColumnListButton = styled(ListItemButton)(({ theme }) => ({
  borderRadius: 8,
  paddingTop: theme.spacing(0.5),
  paddingBottom: theme.spacing(0.5),
  '&:hover': { backgroundColor: alpha(theme.palette.primary.main, 0.08) },
  '& .MuiListItemText-primary': {
    fontFamily: FONT_MONO,
    fontSize: '0.85rem',
    color: theme.palette.text.primary,
  },
}));
